import React from 'react';
import { Award, Users, Heart } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="about" className="relative py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative overflow-hidden" style={{ borderRadius: '0px' }}>
              <img
                src="https://images.unsplash.com/photo-1618312980096-873bd19759a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxhdXRvJTIwcmVwYWlyJTIwc2hvcHxlbnwwfHx8fDE3NjUyNDM4NzJ8MA&ixlib=rb-4.1.0&q=85"
                alt="K&B Auto Services Shop"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            </div>
            
            {/* Red Accent Border */}
            <div className="absolute -bottom-4 -right-4 w-full h-full border-2 border-red-600 -z-10"></div>
          </div>

          {/* Content Side */}
          <div>
            <div className="inline-block mb-4">
              <span className="text-red-600 text-sm font-bold tracking-widest uppercase">About Us</span>
              <div className="h-0.5 bg-red-600 mt-2"></div>
            </div>
            
            <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6 leading-tight">
              About K&B Auto Services
            </h2>
            
            <div className="space-y-4 text-white/80 text-lg leading-relaxed">
              <p>
                We are a small, local, family-run auto repair shop proudly serving Worcester, MA and the surrounding communities. At K&B Auto Services, we believe in building lasting relationships with our customers through honest work and transparent communication.
              </p>
              
              <p>
                Our team of experienced technicians specializes in comprehensive diagnostics, repairs, and preventive maintenance for both foreign and domestic vehicles. We treat every car as if it were our own, ensuring quality workmanship and attention to detail on every job.
              </p>
              
              <p>
                Whether you need a routine oil change or complex engine repairs, we're committed to getting you back on the road safely and quickly with fair, competitive pricing.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mt-6">
              <div className="text-center">
                <Award className="w-8 h-8 text-red-600 mx-auto mb-2" />
                <div className="text-2xl font-bold text-white">10+</div>
                <div className="text-sm text-white/60">Years Experience</div>
              </div>
              <div className="text-center">
                <Users className="w-8 h-8 text-red-600 mx-auto mb-2" />
                <div className="text-2xl font-bold text-white">1000+</div>
                <div className="text-sm text-white/60">Happy Customers</div>
              </div>
              <div className="text-center">
                <Heart className="w-8 h-8 text-red-600 mx-auto mb-2" />
                <div className="text-2xl font-bold text-white">100%</div>
                <div className="text-sm text-white/60">Satisfaction</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;